import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import I18n from 'utils/I18n';
import Cldr from 'utils/Cldr';
import DurationSelect from './DurationSelect';

import styles from './index.scss';

export const I18nPrefix = 'strava.subscriptions.checkout.summary.trial';

class SummaryTrials extends React.Component {
  state = {
    showMoreBillingOptions: false
  };

  handleShowMoreBillingOptions = () => {
    this.setState((prevState) => ({
      showMoreBillingOptions: !prevState.showMoreBillingOptions
    }));
  };

  isYearlyDuration = () => {
    const { cartData } = this.props;
    return cartData.duration === 'yearly';
  };

  totalPrimaryPrice = () => {
    const { cartData } = this.props;

    return this.isYearlyDuration()
      ? cartData.yearlyTotal
      : cartData.monthlyTotal;
  };

  renderPerMonthPrice = (price, currency) =>
    I18n.t_html(`${I18nPrefix}.per_month`, {
      price: Cldr.formatCurrency(price, currency)
    });

  renderPerYearPrice = (price, currency) =>
    I18n.t_html(`${I18nPrefix}.per_year`, {
      price: Cldr.formatCurrency(price, currency)
    });

  render() {
    const { cartData, trialInfo } = this.props;
    const { currency } = cartData;
    const isYearlyDuration = this.isYearlyDuration();

    const totalPrimaryText = isYearlyDuration
      ? this.renderPerYearPrice(this.totalPrimaryPrice(), currency)
      : this.renderPerMonthPrice(this.totalPrimaryPrice(), currency);

    return (
      <div className={styles.checkoutSummary}>
        <div className={`${styles.card} card`}>
          <div className={`${styles.inset} ${styles.overviewSection}`}>
            <div className={styles.overviewTitle}>
              {I18n.t(`${I18nPrefix}.title`, {
                days: trialInfo.trialLength
              })}
            </div>
            <div className={styles.overviewDescription}>
              {I18n.t(`${I18nPrefix}.description`)}
            </div>
          </div>

          <div className={`${styles.inset} ${styles.pricingSection}`}>
            <div className={`${styles.lineItem} ${styles.billedToday}`}>
              <div className={styles.priceRow}>
                <span>{I18n.t(`${I18nPrefix}.billed.today`)}</span>
                <span>
                  {Cldr.formatCurrency(cartData.billedToday, cartData.currency)}
                </span>
              </div>
            </div>

            <div className={`${styles.lineItem} ${styles.billedAfterTrial}`}>
              <div className={styles.priceRow}>
                <span>{I18n.t(`${I18nPrefix}.billed.after_trial`)}</span>
                <span>{totalPrimaryText}</span>
              </div>
              {!this.state.showMoreBillingOptions && (
                <div className={styles.moreBillingOptions}>
                  <button
                    className={`btn btn-link ${styles.moreBillingOptionsButton}`}
                    onClick={this.handleShowMoreBillingOptions}
                  >
                    {I18n.t(`${I18nPrefix}.more_billing_options`)}
                  </button>
                </div>
              )}
            </div>

            {this.state.showMoreBillingOptions && <DurationSelect />}
          </div>

          <div className={`${styles.inset} ${styles.footnoteSection}`}>
            {I18n.t(`${I18nPrefix}.cancel`)}
          </div>
        </div>
      </div>
    );
  }
}

SummaryTrials.defaultProps = {
  trialInfo: null
};

SummaryTrials.propTypes = {
  duration: PropTypes.string.isRequired,
  cartData: PropTypes.shape({
    duration: PropTypes.string.isRequired,
    currency: PropTypes.string.isRequired,
    monthlyTotal: PropTypes.number.isRequired,
    yearlyTotal: PropTypes.number.isRequired,
    recurringAmount: PropTypes.number.isRequired,
    billedToday: PropTypes.number.isRequired
  }).isRequired,
  trialInfo: PropTypes.shape({
    trialLength: PropTypes.number
  })
};

const mapStateToProps = (state) => ({
  duration: state.duration,
  cartData: state.products[state.duration],
  trialInfo: state.trialInfo
});

export default connect(mapStateToProps)(SummaryTrials);
